import React from 'react'

import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import AllRoutes from './Components/AllRoutes/AllRoutes'

import './style.css'
import 'react-toastify/dist/ReactToastify.css'
import NavbarContextProvider from './Context/NavbarContext'
import { ChakraProvider } from '@chakra-ui/react'
import theme from './theme'
import GetStartedContextProvider from './Context/GetStartedContext'

function App() {
  return (
    <>
      <div className='App'>
        <ChakraProvider theme={theme}>
          <NavbarContextProvider>
            <ToastContainer toastStyle={{ backgroundColor: '#171717' }} />
            <GetStartedContextProvider>
              <BrowserRouter>
                <AllRoutes />
              </BrowserRouter>
            </GetStartedContextProvider>
          </NavbarContextProvider>
        </ChakraProvider>
      </div>
    </>
  )
}

export default App
